import { render, staticRenderFns } from "./WPPageManagerAddPageWizard.vue?vue&type=template&id=52d9e438&"
import script from "./WPPageManagerAddPageWizard.vue?vue&type=script&lang=ts&"
export * from "./WPPageManagerAddPageWizard.vue?vue&type=script&lang=ts&"
import style0 from "./WPPageManagerAddPageWizard.vue?vue&type=style&index=0&id=52d9e438&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports